import { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Phone, MapPin } from "lucide-react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { SITE } from "@/data/site";

const MobileBar = () => (
  <div className="fixed inset-x-3 bottom-3 z-50 grid grid-cols-2 gap-2 rounded-full border border-cream/10 bg-cocoa/90 p-1.5 backdrop-blur-xl md:hidden" data-testid="mobile-action-bar">
    <a href={SITE.tel} data-testid="mobile-bar-call-btn" className="flex items-center justify-center gap-2 rounded-full bg-hibiscus py-3 text-sm font-semibold text-cream active:scale-95">
      <Phone className="h-4 w-4" /> Call
    </a>
    <a href={SITE.directions} target="_blank" rel="noopener noreferrer" data-testid="mobile-bar-directions-btn" className="flex items-center justify-center gap-2 rounded-full bg-cream py-3 text-sm font-semibold text-cocoa active:scale-95">
      <MapPin className="h-4 w-4" /> Directions
    </a>
  </div>
);

export const Layout = () => {
  const { pathname } = useLocation();
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true, anchors: { offset: -150 } });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    lenisRef.current?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="grain min-h-screen bg-cream font-body text-cocoa">
      <Header />
      <main><Outlet /></main>
      <Footer />
      <MobileBar />
    </div>
  );
};
